import * as L from 'leaflet';
import { AriaLabelDivIcon } from './aria-label-div-icon';
import { TranslationService } from '../../../../services/translation.service';

// See https://stackoverflow.com/questions/65691920/extend-leaflet-marker-with-typescript
// Based on code in https://github.com/domoritz/leaflet-locatecontrol/blob/7e0fa72561616e81600b3728bb48e58b8aa38741/src/L.Control.Locate.js
export default class CurrentLocationMarker extends L.Marker {
  private translationCurrentPosition: string;

  constructor(latLng: L.LatLngExpression, options?: L.MarkerOptions) {
    super(latLng, options);
    this.translationCurrentPosition = TranslationService.get('common.map.currentposition');
    const iconSvg = this.getIconSVG(this.options, this.createStyle(this.options));
    this.setIcon(
      new AriaLabelDivIcon(
        {
          className: iconSvg.className,
          iconSize: [iconSvg.w, iconSvg.h],
          html: iconSvg.svg,
        },
        this.translationCurrentPosition
      )
    );
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private createStyle(opt: any): string {
    let style = '';

    if (opt.color !== undefined) {
      style += `stroke:${opt.color};`;
    }
    if (opt.weight !== undefined) {
      style += `stroke-width:${opt.weight};`;
    }
    if (opt.fillColor !== undefined) {
      style += `fill:${opt.fillColor};`;
    }
    if (opt.fillOpacity !== undefined) {
      style += `fill-opacity:${opt.fillOpacity};`;
    }
    if (opt.opacity !== undefined) {
      style += `opacity:${opt.opacity};`;
    }
    return style;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private getIconSVG(options: any, style: any) {
    const r = options.radius;
    const w = options.weight;
    const s = r + w;
    const s2 = s * 2;

    const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${s2}" height="${s2}" version="1.1" viewBox="-${s} -${s} ${s2} ${s2}"><circle r="${r}" style="${style}" /></svg>`;
    return {
      className: 'button-div-icon current-location-marker',
      svg,
      w: s2,
      h: s2,
    };
  }
}
